import React from 'react';
import { CalendarClock, Building2, UserRound } from 'lucide-react';

export default function BookingSummaryCard({
  candidateName,
  participantLabel,
  participantValue,
  slotDisplay,
  timezoneName,
  statusLabel,
  jobTitle,
}) {
  return (
    <div className="li-booking-summary">
      <div className="li-booking-summary-grid">
        <div className="li-booking-summary-item">
          <span className="li-booking-summary-icon">
            <UserRound size={16} />
          </span>
          <div>
            <div className="li-booking-summary-label">Candidate</div>
            <div className="li-booking-summary-value">{candidateName || 'Candidate'}</div>
          </div>
        </div>
        <div className="li-booking-summary-item">
          <span className="li-booking-summary-icon">
            <Building2 size={16} />
          </span>
          <div>
            <div className="li-booking-summary-label">{participantLabel || 'Interviewer'}</div>
            <div className="li-booking-summary-value">{participantValue || '—'}</div>
          </div>
        </div>
      </div>

      <div className="li-booking-slot-card">
        <div className="li-booking-slot-card-head">
          <CalendarClock size={18} />
          <div>
            <div className="li-booking-slot-card-label">Current interview time</div>
            {statusLabel ? <div className="li-booking-slot-card-status">{statusLabel}</div> : null}
          </div>
        </div>
        <div className="li-booking-slot-card-value">{slotDisplay || 'Scheduled slot'}</div>
        {jobTitle ? <div className="li-booking-slot-card-meta">Role: {jobTitle}</div> : null}
        {timezoneName ? <div className="li-booking-slot-card-meta">Timezone: {timezoneName}</div> : null}
      </div>
    </div>
  );
}
